<div class="trustpilot-widget mt-4 z-0" data-locale="en-US" data-template-id="5419b732fbfb950b10de65e5"
  data-businessunit-id="67eeac89e3692dd8cf65df57" data-style-height="24px" data-style-width="100%">
  <a href="https://www.trustpilot.com/review/vnumber.com" target="_blank" rel="noopener">
    Trustpilot
  </a>
</div>